<template>
  <div>    
    <div class="row">
      <div class="col-lg-12 col-md-12 box-release">
        <div class="notas-versao-item">
          <div class="notas-versao-header">
            <span class="notas-versao-v">v.326</span>
            <span class="notas-versao-data">04/07/2021</span>
          </div>
          <div class="notas-versao-conteudo">
            <p><i class="fa fa-check" aria-hidden="true"></i> {{ $t("60") }}</p>
          </div>
        </div>
        <div class="notas-versao-item">
          <div class="notas-versao-header">
            <span class="notas-versao-v">v.325</span>
            <span class="notas-versao-data">03/10/2021</span>
          </div>
          <div class="notas-versao-conteudo">
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("61") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("62") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("63") }}</p>
          </div>
        </div>
        <div class="notas-versao-item">
          <div class="notas-versao-header">
            <span class="notas-versao-v">v.323</span>
            <span class="notas-versao-data">02/17/2021</span>
          </div>
          <div class="notas-versao-conteudo">
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("64") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("65") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("66") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("67") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("68") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("69") }}</p>
          </div>
        </div>
        <div class="notas-versao-item">
          <div class="notas-versao-header">
            <span class="notas-versao-v">v.218</span>
            <span class="notas-versao-data">03/17/2020</span>
          </div>
          <div class="notas-versao-conteudo">
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("70") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("71") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("72") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("73") }}</p>
           
          </div>
        </div> 
        <div class="notas-versao-item">
          <div class="notas-versao-header">
            <span class="notas-versao-v">v.215</span>
            <span class="notas-versao-data">03/11/2020</span>
          </div>
          <div class="notas-versao-conteudo">
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("74") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("75") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("76") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("77") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("78") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("79") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("80") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("81") }}</p>
          </div>
        </div> 
        <div class="notas-versao-item">
          <div class="notas-versao-header">
            <span class="notas-versao-v">v.197</span>
            <span class="notas-versao-data">02/26/2020</span>
          </div>
          <div class="notas-versao-conteudo">
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("82") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("83") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("84") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("85") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("86") }}</p>
          </div>
        </div>
        <div class="notas-versao-item">
          <div class="notas-versao-header">
            <span class="notas-versao-v">v.172</span>
            <span class="notas-versao-data">02/03/2020</span>
          </div>
          <div class="notas-versao-conteudo">
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("87") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("88") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("89") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("90") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("91") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("92") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("93") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("94") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("95") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("96") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("97") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("98") }}</p>
          </div>
        </div>
        <div class="notas-versao-item">
          <div class="notas-versao-header">
            <span class="notas-versao-v">v.01</span>
            <span class="notas-versao-data">01/28/2020</span>
          </div>
          <div class="notas-versao-conteudo">
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("99") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("100") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("101") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("102") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("103") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("104") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("105") }}</p>
            <p><i class="fa fa-check" aria-hidden="true"></i>{{ $t("106") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueTabs from 'vue-nav-tabs'
  Vue.use(VueTabs)

  export default {
    data () {
      return {
        activeName: 'first'
      }
    }
  }
</script>
<style>
.box-release{
  margin-top: 25px;
}
.notas-versao-item{
  margin: 10px 0px;
}
.notas-versao-header{
  margin-bottom: 10px;
}
.notas-versao-v{
  color: #627c88;
}
.notas-versao-data{
  color: #627c88;
  font-weight: bold;
  margin-left: 10px;
}
.notas-versao-item{
  margin:35px 0px;
}
.notas-versao-conteudo{
  color:#fff;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Release.vue